import store from "@/store";
import { get } from "lodash";

export default async (to, from, next) => {
  await store.dispatch("setSelectedInformation", get(to, "params.id"));
  next();
};
